
  import Vue from 'vue';
  import PopularCategoryCard from '@/components/PopularCategoryCard';
export default {
  components: {
    PopularCategoryCard
  },
  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: 'og:title',
          property: 'og:title',
          content: this.title,
        },
        {
          hid: 'twitter:title',
          property: 'twitter:title',
          content: this.title,
        },

        {
  hid: 'description',
  name: 'description',
  content: 'Explore the best of South Goa with unforgettable sightseeing experiences. From stunning beaches to historical landmarks, discover everything this vibrant region has to offer.',
},
{
  hid: 'og:description',
  property: 'og:description',
  content: 'Discover the top sightseeing spots in South Goa. From beautiful beaches to historic sites, explore the vibrant culture and scenic landscapes of this amazing region.',
},
{
  hid: 'twitter:description',
  property: 'twitter:description',
  content: 'Enjoy the best of South Goa sightseeing. Visit stunning beaches, historic landmarks, and vibrant local spots for a truly unforgettable experience.',
},



        {
          hid: 'keywords',
          name: 'keywords',
          content: 'south goa sightseeing, south goa sightseeing package by car, south goa sightseeing package by bus, south goa sightseeing places, south goa sightseeing packages, south goa sightseeing itinerary, south goa sightseeing package by ac bus, south goa sightseeing package by car price, north goa and south goa sightseeing, south goa sightseeing full day tour, south goa sightseeing places list',
        },

      ],
    };
  },

  components: {},
  data() {
    return {

      reasons: [
    {
      title: "Stunning Destinations",
      text: "Discover breathtaking views and hidden gems with the best sightseeing spots in Goa!",
    },
    {
      title: "Fun for Everyone",
      text: "Whether you're an adventure lover or prefer a relaxed tour, there's something for everyone!",
    },
    {
      title: "Local Guides",
      text: "Our experienced guides will take you to the top attractions and share fascinating insights.",
    },
    {
      title: "Easy Booking",
      text: "Book your perfect sightseeing tour effortlessly through the Goa App at great rates!",
    },
  ],

    
      title: 'South Goa Sightseeing - South Goa Sightseeing Places and Tour',
    };
  },

  jsonld() {
  return {
    '@context': 'https://schema.org',
    '@graph': [
    {
                "@type": "ImageObject",
                "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2022-03-03T15%3A48%3A50.840Zpalolem-beach-4.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=DRLB24UzEBrrceHccrh7yaHyiH9p%2FPJEpXSl1sd%2F4jKFKQNOKfSijEBWV%2FmaxcdYeEcnlxLeiGSrY9d6OHFM0CzH3oS3OicriiNX6AzAJfmO3%2FDFfybUBQ3ZuHRsbAKNtXm6noZkcdphYIcK2oKAP1S26nTBXd0aIBAC4h6l6AGHPUybe86McJuwGaUx8gzCs9%2BmE7IAdMQgek4vXhpLuhPb5JrcgYgEjlj%2BrrGAqODDMPuHtE56b6wxyqfhc7RG0DByhdEBBZFsUjNTPHpMTvt6YvCybGttCjZ%2B7xhDl0FjOg1QmQ5fpyH1PoYrYvbUao%2BDXQMqpcLRN4kMTdfLBg%3D%3D',
                "url": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2022-03-03T15%3A48%3A50.840Zpalolem-beach-4.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=DRLB24UzEBrrceHccrh7yaHyiH9p%2FPJEpXSl1sd%2F4jKFKQNOKfSijEBWV%2FmaxcdYeEcnlxLeiGSrY9d6OHFM0CzH3oS3OicriiNX6AzAJfmO3%2FDFfybUBQ3ZuHRsbAKNtXm6noZkcdphYIcK2oKAP1S26nTBXd0aIBAC4h6l6AGHPUybe86McJuwGaUx8gzCs9%2BmE7IAdMQgek4vXhpLuhPb5JrcgYgEjlj%2BrrGAqODDMPuHtE56b6wxyqfhc7RG0DByhdEBBZFsUjNTPHpMTvt6YvCybGttCjZ%2B7xhDl0FjOg1QmQ5fpyH1PoYrYvbUao%2BDXQMqpcLRN4kMTdfLBg%3D%3D',
                "contentUrl": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2022-03-03T15%3A48%3A50.840Zpalolem-beach-4.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=DRLB24UzEBrrceHccrh7yaHyiH9p%2FPJEpXSl1sd%2F4jKFKQNOKfSijEBWV%2FmaxcdYeEcnlxLeiGSrY9d6OHFM0CzH3oS3OicriiNX6AzAJfmO3%2FDFfybUBQ3ZuHRsbAKNtXm6noZkcdphYIcK2oKAP1S26nTBXd0aIBAC4h6l6AGHPUybe86McJuwGaUx8gzCs9%2BmE7IAdMQgek4vXhpLuhPb5JrcgYgEjlj%2BrrGAqODDMPuHtE56b6wxyqfhc7RG0DByhdEBBZFsUjNTPHpMTvt6YvCybGttCjZ%2B7xhDl0FjOg1QmQ5fpyH1PoYrYvbUao%2BDXQMqpcLRN4kMTdfLBg%3D%3D',
                "caption": 'Goa App',
                "inLanguage": "en-US",
                "width": 800,
                "height": 440
            }, 
            {
            "@type": "BlogPosting",
            "@id": `https://www.goa.app/south-goa-sightseeing`,
                mainEntityOfPage: {
                    '@type': 'WebPage',
                    '@id': `https://www.goa.app/south-goa-sightseeing`
                },
                "headline": 'Goa App',
                "name": 'Goa App',
                description: '',
                datePublished: '2024-10-26T20:14:36+00:00',
                dateModified: '2024-10-26T20:14:36+00:00',
                author: {
                    '@type': 'Person',
                    name: 'Goa App',
                    url: "https://goa.app"
                },
                publisher: {
                    '@type': 'Organization',
                    "@id": "https://goa.app",
                    name: 'Goa App',
                    logo: {
                        '@type': 'ImageObject',
                        url: 'https://goa.app/goa-app-logo.svg'
                    }
                },
                "image": {
                    "@type": "ImageObject",
                    "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2022-03-03T15%3A48%3A50.840Zpalolem-beach-4.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=DRLB24UzEBrrceHccrh7yaHyiH9p%2FPJEpXSl1sd%2F4jKFKQNOKfSijEBWV%2FmaxcdYeEcnlxLeiGSrY9d6OHFM0CzH3oS3OicriiNX6AzAJfmO3%2FDFfybUBQ3ZuHRsbAKNtXm6noZkcdphYIcK2oKAP1S26nTBXd0aIBAC4h6l6AGHPUybe86McJuwGaUx8gzCs9%2BmE7IAdMQgek4vXhpLuhPb5JrcgYgEjlj%2BrrGAqODDMPuHtE56b6wxyqfhc7RG0DByhdEBBZFsUjNTPHpMTvt6YvCybGttCjZ%2B7xhDl0FjOg1QmQ5fpyH1PoYrYvbUao%2BDXQMqpcLRN4kMTdfLBg%3D%3D',
                    "url": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2022-03-03T15%3A48%3A50.840Zpalolem-beach-4.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=DRLB24UzEBrrceHccrh7yaHyiH9p%2FPJEpXSl1sd%2F4jKFKQNOKfSijEBWV%2FmaxcdYeEcnlxLeiGSrY9d6OHFM0CzH3oS3OicriiNX6AzAJfmO3%2FDFfybUBQ3ZuHRsbAKNtXm6noZkcdphYIcK2oKAP1S26nTBXd0aIBAC4h6l6AGHPUybe86McJuwGaUx8gzCs9%2BmE7IAdMQgek4vXhpLuhPb5JrcgYgEjlj%2BrrGAqODDMPuHtE56b6wxyqfhc7RG0DByhdEBBZFsUjNTPHpMTvt6YvCybGttCjZ%2B7xhDl0FjOg1QmQ5fpyH1PoYrYvbUao%2BDXQMqpcLRN4kMTdfLBg%3D%3D',
                    "height": "440",
                    "width": "800"
                },
                "url": `https://www.goa.app/south-goa-sightseeing`,
                "isPartOf": {
                    "@type": "Blog",
                    "@id": "https://www.goa.app/",
                    "name": "Goa App Blog",
                    "publisher": {
                        "@type": "Organization",
                        "@id": "https://goa.app",
                        "name": "Goa App"
                    }
                },
            },
            
            {
  "@type": "Product",
  "name": "South Goa Sightseeing - Book @ ₹399 Flat 33% Off",
  "description": "Experience the best sightseeing in South Goa, where stunning landscapes, vibrant culture, and iconic landmarks come together for an unforgettable journey filled with picturesque moments.",
  "image": "https://storage.googleapis.com/goa-app-12a91.appspot.com/2022-03-03T15%3A48%3A50.840Zpalolem-beach-4.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=DRLB24UzEBrrceHccrh7yaHyiH9p%2FPJEpXSl1sd%2F4jKFKQNOKfSijEBWV%2FmaxcdYeEcnlxLeiGSrY9d6OHFM0CzH3oS3OicriiNX6AzAJfmO3%2FDFfybUBQ3ZuHRsbAKNtXm6noZkcdphYIcK2oKAP1S26nTBXd0aIBAC4h6l6AGHPUybe86McJuwGaUx8gzCs9%2BmE7IAdMQgek4vXhpLuhPb5JrcgYgEjlj%2BrrGAqODDMPuHtE56b6wxyqfhc7RG0DByhdEBBZFsUjNTPHpMTvt6YvCybGttCjZ%2B7xhDl0FjOg1QmQ5fpyH1PoYrYvbUao%2BDXQMqpcLRN4kMTdfLBg%3D%3D",
  "review": {
    "@type": "Review",
    "reviewRating": {
      "@type": "Rating",
      "ratingValue": "5",
      "bestRating": "5"
    },
    "author": {
      "@type": "Person",
      "name": "Goa App"
    }
  },
  "brand": {
    "@type": "Brand",
    "name": "Goa App"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "ratingCount": "89",
    "ratingValue": "5",
    "reviewCount": "44"
  },
  "offers": {
    "@type": "Offer",
    "price": "399",
    "priceValidUntil": "2025-12-31",
    "priceCurrency": "INR",
    "availability": "InStock",
    "seller": {
      "@type": "Organization",
      "name": "Goa App"
    }
  }
},

            {
        "@type": "WebPage",
        "@id": "https://www.goa.app/south-goa-sightseeing",
        "url": "https://www.goa.app/south-goa-sightseeing",
        "name": "South Goa Sightseeing",
        "isPartOf": {
            "@id": "https://www.goa.app/#website"
        },
        "primaryImageOfPage": {
            "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2022-03-03T15%3A48%3A50.840Zpalolem-beach-4.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=DRLB24UzEBrrceHccrh7yaHyiH9p%2FPJEpXSl1sd%2F4jKFKQNOKfSijEBWV%2FmaxcdYeEcnlxLeiGSrY9d6OHFM0CzH3oS3OicriiNX6AzAJfmO3%2FDFfybUBQ3ZuHRsbAKNtXm6noZkcdphYIcK2oKAP1S26nTBXd0aIBAC4h6l6AGHPUybe86McJuwGaUx8gzCs9%2BmE7IAdMQgek4vXhpLuhPb5JrcgYgEjlj%2BrrGAqODDMPuHtE56b6wxyqfhc7RG0DByhdEBBZFsUjNTPHpMTvt6YvCybGttCjZ%2B7xhDl0FjOg1QmQ5fpyH1PoYrYvbUao%2BDXQMqpcLRN4kMTdfLBg%3D%3D'
        },
        "image": {
            "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2022-03-03T15%3A48%3A50.840Zpalolem-beach-4.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=DRLB24UzEBrrceHccrh7yaHyiH9p%2FPJEpXSl1sd%2F4jKFKQNOKfSijEBWV%2FmaxcdYeEcnlxLeiGSrY9d6OHFM0CzH3oS3OicriiNX6AzAJfmO3%2FDFfybUBQ3ZuHRsbAKNtXm6noZkcdphYIcK2oKAP1S26nTBXd0aIBAC4h6l6AGHPUybe86McJuwGaUx8gzCs9%2BmE7IAdMQgek4vXhpLuhPb5JrcgYgEjlj%2BrrGAqODDMPuHtE56b6wxyqfhc7RG0DByhdEBBZFsUjNTPHpMTvt6YvCybGttCjZ%2B7xhDl0FjOg1QmQ5fpyH1PoYrYvbUao%2BDXQMqpcLRN4kMTdfLBg%3D%3D'
        },
        "thumbnailUrl": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2022-03-03T15%3A48%3A50.840Zpalolem-beach-4.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=DRLB24UzEBrrceHccrh7yaHyiH9p%2FPJEpXSl1sd%2F4jKFKQNOKfSijEBWV%2FmaxcdYeEcnlxLeiGSrY9d6OHFM0CzH3oS3OicriiNX6AzAJfmO3%2FDFfybUBQ3ZuHRsbAKNtXm6noZkcdphYIcK2oKAP1S26nTBXd0aIBAC4h6l6AGHPUybe86McJuwGaUx8gzCs9%2BmE7IAdMQgek4vXhpLuhPb5JrcgYgEjlj%2BrrGAqODDMPuHtE56b6wxyqfhc7RG0DByhdEBBZFsUjNTPHpMTvt6YvCybGttCjZ%2B7xhDl0FjOg1QmQ5fpyH1PoYrYvbUao%2BDXQMqpcLRN4kMTdfLBg%3D%3D',
        "datePublished": "2024-10-26T20:14:36+00:00",
        "dateModified": "2024-10-26T20:14:36+00:00",
        "description": "South Goa sightseeing Tour offers breathtaking views of stunning beaches, vibrant culture, and scenic landscapes. It’s an ideal destination for travelers looking to explore beautiful sunsets, historic sites like Aguada Fort, and lush greenery, creating unforgettable memories along the way.",
        "breadcrumb": {
            "@id": "https://www.goa.app/south-goa-sightseeing/#breadcrumb"
        },
        "inLanguage": "en-US",
        "potentialAction": [{
            "@type": "ReadAction",
            "target": ["https://www.goa.app/south-goa-sightseeing"]
        }]
      },
      {
        "@type": "FAQPage",
  "mainEntity": [
  {
        "@type": "Question",
        "name": "What are the best sightseeing spots in South Goa?",
        "acceptedAnswer": {
            "@type": "Answer",
            "text": "Some of the best sightseeing spots in South Goa include Colva Beach, Basilica of Bom Jesus, Se Cathedral, and the peaceful Palolem Beach."
        }
    },
    {
        "@type": "Question",
        "name": "What types of tours are available for South Goa sightseeing?",
        "acceptedAnswer": {
            "@type": "Answer",
            "text": "In South Goa, you can choose from full-day tours, private car tours, and group bus tours, with options for guided trips."
        }
    },
    {
        "@type": "Question",
        "name": "How much does a South Goa sightseeing tour cost?",
        "acceptedAnswer": {
            "@type": "Answer",
            "text": "South Goa sightseeing tours typically start from ₹399 for group bus tours and ₹3,499 for private car rentals, depending on the package."
        }
    },
    {
        "@type": "Question",
        "name": "Can I customize my South Goa sightseeing tour?",
        "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, many operators offer customizable South Goa sightseeing packages, allowing you to pick your preferred locations."
        }
    },
    {
        "@type": "Question",
        "name": "What is the best time for sightseeing in South Goa?",
        "acceptedAnswer": {
            "@type": "Answer",
            "text": "The best time for sightseeing in South Goa is from November to February, when the weather is cooler and more comfortable for outdoor activities."
        }
    },
    {
        "@type": "Question",
        "name": "Are there any restrictions on visiting certain sightseeing spots?",
        "acceptedAnswer": {
            "@type": "Answer",
            "text": "Some locations in South Goa may have entry fees or time restrictions, especially at popular tourist spots like churches and beaches."
        }
    },
    {
        "@type": "Question",
        "name": "Do sightseeing packages include a guide?",
        "acceptedAnswer": {
            "@type": "Answer",
            "text": "Many South Goa sightseeing packages come with an experienced guide to provide historical and cultural insights about the region."
        }
    },
    {
        "@type": "Question",
        "name": "Can I choose my sightseeing locations?",
        "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, you can work with your tour operator to create a personalized itinerary based on your interests in South Goa."
        }
    },
    {
        "@type": "Question",
        "name": "What should I wear for a sightseeing tour in South Goa?",
        "acceptedAnswer": {
            "@type": "Answer",
            "text": "Wear comfortable and breathable clothing, as South Goa's attractions often involve walking and outdoor exploration. Don’t forget sun protection!"
        }
    },
    {
        "@type": "Question",
        "name": "How do I book a South Goa sightseeing tour?",
        "acceptedAnswer": {
            "@type": "Answer",
            "text": "You can book a South Goa sightseeing tour through local travel agencies or online platforms like the Goa App, which offer detailed packages."
        }
    }
        ]
      }
    ]
  };
},


};



  